<script setup lang="ts">
import type { CollectionFragment } from '#graphql-operations'

defineProps<{
  collection: CollectionFragment
}>()
</script>

<template>
  <NuxtLinkLocale
    class="flex flex-col items-center justify-center"
    :to="`/collections/${collection.id}/${collection.slug}`"
  >
    <div class="relative h18 w18 shrink-0 overflow-hidden rounded-full bg-slate-50 ring-2 ring-black/5 transition duration-300 ease-in-out sm:h21.5 sm:w21.5 hover:shadow-md">
      <NuxtImg
        :src="collection.featuredAsset?.preview ?? 'image'" :alt="collection.name"
        class="absolute left-0 top-0 h-full w-full rounded-full object-cover object-center transition-transform duration-300 ease-in-out hover:scale-110"
        loading="lazy"
      />
    </div>
    <div class="line-clamp-2 mt2 w32 text-center text-sm text-slate-900 fw600 lg:text-sm sm:text-base dark:text-slate-100">
      {{ collection.name }}
    </div>
  </NuxtLinkLocale>
</template>
